/** @format */

import React from 'react';

import moment from 'moment';

import { Avatar, Row, Col } from 'antd';
import { Comment } from '@ant-design/compatible';
import { UserOutlined } from '@ant-design/icons';

import './style.css';

function List(props) {
	return (
		<>
			{props.criterionQf.map((item, i) => (
				<Comment
					className="ph-complaint-book-list-content"
					key={i}
					author={<h3 className="ph-complaint-book-list-name">{item.qf_email}</h3>}
					avatar={<Avatar icon={<UserOutlined size={32} />} />}
					content={
						<>
							<Row className="ph-complaint-book-list-user-row">
								<Col span={2}>Identificación: {item.rut}</Col>
								<Col span={3}>code_internal: {item.code_internal}</Col>
								<Col span={2}>TRX ID: {item.trx_id}</Col>
								<Col span={2}>Status: {item.status}</Col>
							</Row>
							<h3>Criterio:</h3>
							<p>{item.observation}</p>
						</>
					}
					datetime={<span>Fecha: {moment.unix(item.created_at).format('DD/MM/YYYY')}</span>}
				/>
			))}
		</>
	);
}

export default List;
